import react from "react";

const About = () => {
  return (
    <>
      <div className="aboutting">This is the About Page of my website...</div>
    </>
  );
};

export default About;
